import Vue from 'vue';
import VueRouter from 'vue-router';
import { GeneralPaths } from './routesNames';

Vue.use(VueRouter);

var routes = [];

Object.values(GeneralPaths).forEach((entry) => {
	routes.push(entry);
});

routes.forEach((route) => {
	var components = {};
	if (route.view) {
		components['default'] = route.view;
	}
	route['components'] = components;
});

const router = new VueRouter({
	mode: 'history',
	routes,
});

/*
router.beforeEach((to, from, next) => {
	let user = auth.currentUser;
	if (to.matched[0].meta.requiresAuth) {
		if (user) {
			next();
		} else {
			next({
				name: LoginPaths.login.title,
			});
		}
	} else if (to.matched[0].meta.alreadyAuth) {
		if (user) {
			next({
				name: DashboardPaths.base.title,
			});
		} else {
			next();
		}
	} else {
		next();
	}
});
*/

export default router;
